import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OverlayService {
  private headerHeight = 60;
  private alertHeight = 48;

  private overlaySubject = new BehaviorSubject<any>(null);
  private alertVisibleSubject = new BehaviorSubject<boolean>(false);

  // Overlay observable
  overlay$ = this.overlaySubject.asObservable();

  // Alert visible observable
  alertVisible$ = this.alertVisibleSubject.asObservable();

  // Dynamische Höhe abhängig von Alert
  overlayHeight$ = this.alertVisible$.pipe(
    map(isAlertVisible => {
      const totalTopOffset = this.headerHeight + (isAlertVisible ? this.alertHeight : 0);

      return `calc(100vh - ${totalTopOffset}px)`;
    })
  );

  constructor() {}

  // Wird vom AppComponent gesetzt
  setAlertVisible(isVisible: boolean) {
    this.alertVisibleSubject.next(isVisible);
  }

  setOverlay(overlayData: any) {
    this.overlaySubject.next(overlayData);
  }

  public getOverlay() {
    return this.overlaySubject;
  }

  closeOverlay() {
    this.overlaySubject.next(null);
  }

  getCurrentHeight(): string {
    const isAlertVisible = this.alertVisibleSubject.value;
    const totalTopOffset = this.headerHeight + (isAlertVisible ? this.alertHeight : 0);

    return `calc(100vh - ${totalTopOffset}px)`;
  }
}
/*
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OverlayService {

  overlay: BehaviorSubject<any>;

  constructor() {
    this.overlay = new BehaviorSubject<any>(null);
  }

  public setOverlay(overlaydata) {
    this.overlay.next(overlaydata);
  }

  public closeOverlay() {
    this.overlay.next(null);
  }

  public getOverlay() {
    return this.overlay;
  }

}
  */
